import { Box } from "@material-ui/core"
import React from "react"
import styled from "styled-components"

// TODO: set css with resposive breakpoints
const StyledTabWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  .tabpanel {
    color: ${(p) => p.theme.colors.lightGrey};
    padding: 0;
  }
`

interface TabPanelProps {
  children?: React.ReactNode
  index: any
  value: any
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props
  return (
    <StyledTabWrapper
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3} className="tabpanel">
          {children}
        </Box>
      )}
    </StyledTabWrapper>
  )
}

export default TabPanel
